module.exports = __webpack_public_path__ + "00ca293b3a136125b672916e666788e9.png";